import React from 'react';
import { Link } from 'react-router-dom';
import { 
  ClipboardDocumentListIcon,
  ShoppingBagIcon,
  CalendarIcon,
  CreditCardIcon,
  ChartBarIcon
} from '@heroicons/react/24/outline';

const AdminIndex = () => {
  const sections = [
    {
      name: 'Analytics',
      description: 'View detailed business insights and performance metrics',
      href: '/admin/analytics',
      icon: ChartBarIcon,
      bgColor: 'bg-indigo-500',
    },
    {
      name: 'Menu Items',
      description: 'Manage restaurant menu items, categories, and pricing',
      href: '/admin/menu',
      icon: ClipboardDocumentListIcon,
      bgColor: 'bg-amber-500',
    },
    {
      name: 'Orders',
      description: 'View and manage customer orders',
      href: '/admin/orders',
      icon: ShoppingBagIcon,
      bgColor: 'bg-blue-500',
    },
    {
      name: 'Bookings',
      description: 'Manage table reservations and event bookings',
      href: '/admin/bookings',
      icon: CalendarIcon,
      bgColor: 'bg-green-500',
    },
    {
      name: 'Payments',
      description: 'View payment history and transactions',
      href: '/admin/payments',
      icon: CreditCardIcon,
      bgColor: 'bg-pink-500',
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {sections.map((section) => (
        <Link
          key={section.name}
          to={section.href}
          className="relative group bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-amber-500 hover:shadow-lg transition-shadow rounded-lg shadow"
        >
          <div>
            <span
              className={`rounded-lg inline-flex p-3 ${section.bgColor} text-white ring-4 ring-white`}
            >
              <section.icon className="h-6 w-6" aria-hidden="true" />
            </span>
          </div>
          <div className="mt-8">
            <h3 className="text-lg font-medium text-gray-900">
              <span className="absolute inset-0" aria-hidden="true" />
              {section.name}
            </h3>
            <p className="mt-2 text-sm text-gray-500">{section.description}</p>
          </div>
          <span
            className="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400"
            aria-hidden="true"
          >
            <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z" />
            </svg>
          </span>
        </Link>
      ))}
    </div>
  );
};

export default AdminIndex;
